var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtominTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15.7px",
    height: "13px",
    viewBox: "472.15 273.5 15.7 13",
    enableBackground: "new 472.15 273.5 15.7 13",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M487.566,275.012c-0.347,0.154-0.708,0.275-1.078,0.363c0.408-0.387,0.714-0.872,0.887-1.412l0,0 c0.049-0.154-0.118-0.288-0.258-0.205l0,0c-0.515,0.305-1.069,0.534-1.647,0.681c-0.034,0.009-0.068,0.013-0.103,0.013 c-0.105,0-0.208-0.039-0.288-0.11c-0.616-0.543-1.407-0.841-2.229-0.841c-0.356,0-0.715,0.055-1.067,0.165 c-1.092,0.339-1.935,1.24-2.2,2.352c-0.099,0.417-0.126,0.834-0.08,1.241c0.005,0.047-0.017,0.079-0.03,0.095 c-0.024,0.027-0.058,0.042-0.093,0.042c-0.004,0-0.008,0-0.012-0.001c-2.391-0.222-4.548-1.374-6.072-3.244l0,0 c-0.078-0.095-0.227-0.084-0.289,0.023l0,0c-0.299,0.512-0.456,1.098-0.456,1.694c0,0.913,0.367,1.774,1.004,2.402 c-0.268-0.064-0.528-0.164-0.769-0.298l0,0c-0.117-0.065-0.26,0.018-0.262,0.152l0,0c-0.017,1.357,0.778,2.564,1.968,3.108 c-0.024,0.001-0.048,0.001-0.072,0.001c-0.189,0-0.38-0.018-0.568-0.054l0,0c-0.131-0.025-0.242,0.099-0.201,0.227l0,0 c0.386,1.206,1.425,2.095,2.667,2.297c-1.031,0.692-2.232,1.057-3.482,1.057l-0.39,0c-0.12,0-0.222,0.078-0.252,0.195 c-0.03,0.115,0.025,0.235,0.128,0.295c1.409,0.82,3.015,1.253,4.647,1.253c1.428,0,2.764-0.283,3.971-0.842 c1.106-0.512,2.084-1.245,2.906-2.177c0.766-0.868,1.364-1.871,1.779-2.98c0.396-1.057,0.605-2.185,0.605-3.261v-0.051 c0-0.173,0.078-0.336,0.215-0.446c0.518-0.42,0.968-0.915,1.34-1.47l0,0C487.882,275.125,487.727,274.941,487.566,275.012 L487.566,275.012z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtominTwitter);
export default __webpack_public_path__ + "static/media/etomin-twitter.8dfa36b12505e55d8e683dfedc4abe13.svg";
export { ForwardRef as ReactComponent };